import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Tablet, Smartphone, SlidersHorizontal } from "lucide-react";
import { DigLogo } from "../components/dig/DigLogo";

export default function Landing() {
  const nav = useNavigate();
  const options = [
    { key: "team", to: "/team", icon: Tablet, title: "Team iPad", sub: "Shared table", color: "#1B7FA8", desc: "El Reparto → Cierre, the game table." },
    { key: "play", to: "/play", icon: Smartphone, title: "Player", sub: "Participant phone", color: "#F2695C", desc: "Join with your room code, get your cards." },
    { key: "console", to: "/console", icon: SlidersHorizontal, title: "Console", sub: "Facilitator", color: "#FDBB2F", desc: "Session control, twists, timers, export." },
  ];
  return (
    <div className="min-h-screen bg-dig-paper text-dig-harbour flex flex-col">
      <header className="px-8 py-6"><DigLogo /></header>
      <main className="flex-1 px-6 md:px-16 pb-16 flex flex-col justify-center max-w-7xl">
        <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="text-dig-blue font-semibold tracking-[0.2em] text-sm mb-3">
          DESTINATION INNOVATION GAME
        </motion.p>
        <motion.h1 initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.05 }}
          className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.02] max-w-3xl">
          Sell your destination <span className="text-dig-coral">a way no partner</span> has been pitched before.
        </motion.h1>
        <p className="mt-5 text-dig-harbour/60 max-w-xl text-lg">Retire the old playbook. Invent a new way in. Choose your screen to start the session.</p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl">
          {options.map((o, i) => {
            const Icon = o.icon;
            return (
              <motion.button
                key={o.key}
                data-testid={`surface-${o.key}-btn`}
                onClick={() => nav(o.to)}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 + i * 0.08 }}
                whileHover={{ y: -6 }}
                className="text-left bg-white rounded-2xl p-7 dig-card-shadow hover:dig-card-lift transition-shadow"
                style={{ borderTop: `6px solid ${o.color}` }}
              >
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5" style={{ background: o.color + "22" }}>
                  <Icon size={28} strokeWidth={2.5} style={{ color: o.color }} />
                </div>
                <h3 className="text-xl font-bold">{o.title}</h3>
                <p className="text-xs font-semibold tracking-widest text-dig-harbour/40 mt-0.5">{o.sub.toUpperCase()}</p>
                <p className="mt-3 text-sm text-dig-harbour/60">{o.desc}</p>
              </motion.button>
            );
          })}
        </div>
      </main>
    </div>
  );
}
